import {BillingAdress} from "./billingAdress";
import {Document} from "./document";
import {Landregisterfolio} from "./landregisterfolio";
import {CustomerInteraction} from "./customerInteraction";
import {PropertyStatus} from "./propertyStatus";
import {PropertyStatistics} from "./property-statistics";
import {Location} from "./location";
import {ObjectOwner} from "./object-owner";
import {v4 as uuid} from "uuid";


export class Property {

  constructor(initialDataSource: string = 'manual') {
    this.dataSource = initialDataSource;
    this.tempId = uuid();
    this.landregisterfolios.push(new Landregisterfolio());
  }

  id: string;
  savedId:string;
  name: string;
  street: string;
  house_number: string;
  zip: string;
  town: string;
  userid: string;
  orderid: string;
  taxNumber: string;
  district: string;
  billingAdress: BillingAdress;
  beneficiaryAddress: BillingAdress;
  landregisterfolios: Array<Landregisterfolio> = [];
  documents: Array<Document> = [];
  dataResearch: boolean;
  authorities: Array<File>;
  contactMail:string;
  customerInteractions: Array<CustomerInteraction> = [];
  status:PropertyStatus;
  isTeilunObtainableOnSite: boolean;
  state: string;
  additionalProductValues: {
    [key: string]: string;
  };
  location: Location;
  tempId: string; // only used in the frontend to match properties for the parcel map
  objectOwnerList: ObjectOwner[] = [];
  dataSource: string;

  propertyStatistics: PropertyStatistics;







}
